import { render, staticRenderFns } from "./CustomersFormShops.vue?vue&type=template&id=318bf861&"
import script from "./CustomersFormShops.vue?vue&type=script&lang=js&"
export * from "./CustomersFormShops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports